<template>
  <b-modal
    id="dtc-item-modal"
    ref="bModal"
    :title="isEdit ? $t('Editar Código DTC') : $t('Adicionar Código DTC')"
    cancel-variant="outline-secondary"
    :ok-title="$t('Salvar')"
    :cancel-title="$t('Cancelar')"
    @ok="handleOk"
    @hidden="resetModal"
    :ok-disabled="isSaving"
  >
    <validation-observer ref="formObserver">
      <b-form @submit.prevent="handleSubmit">
        <b-row>
          <b-col md="6">
            <b-form-group label="SPN" label-for="spn">
              <b-form-input id="spn" v-model="formData.spn" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="FMI" label-for="fmi">
              <b-form-input id="fmi" v-model="formData.fmi" />
            </b-form-group>
          </b-col>
        </b-row>
        
        <b-row>
          <b-col md="6">
            <b-form-group label="DTC*" label-for="dtc">
              <validation-provider #default="{ errors }" name="dtc" rules="required">
                <b-form-input id="dtc" v-model="formData.dtc" :state="errors.length > 0 ? false : null" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label="$t('Severidade') + '*'" label-for="dtcType">
              <validation-provider #default="{ errors }" name="dtcType" rules="required">
                <v-select
                  v-model="formData.dtcType"
                  :options="severityOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-form-group :label="$t('Descrição') + '*'" label-for="description">
              <validation-provider #default="{ errors }" name="description" rules="required">
                <b-form-textarea id="description" v-model="formData.description" :state="errors.length > 0 ? false : null" rows="3" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { BModal, BForm, BRow, BCol, BFormGroup, BFormInput, BFormTextarea } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BModal, BForm, BRow, BCol, BFormGroup, BFormInput, BFormTextarea,
    ValidationProvider, ValidationObserver, vSelect
  },
  props: {
    dtcTableId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isEdit: false,
      isSaving: false,
      formData: {
        id: null,
        spn: '',
        fmi: '',
        dtc: '',
        description: '',
        dtcType: 0
      },
      required,
      severityOptions: [
        { label: this.$t('Não Mapeado'), value: 0 },
        { label: this.$t('Notificação'), value: 1 },
        { label: this.$t('Aviso'), value: 2 },
        { label: this.$t('Perigo'), value: 3 }
      ]
    }
  },
  methods: {
    showModal(item = null) {
      if (item) {
        this.isEdit = true
        this.formData = { ...item }
      } else {
        this.isEdit = false
        this.formData = { id: null, spn: '', fmi: '', dtc: '', description: '', dtcType: 0 }
      }
      this.$refs.bModal.show()
    },
    handleOk(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.handleSubmit()
    },
    handleSubmit() {
      this.$refs.formObserver.validate().then(success => {
        if (success) {
          this.isSaving = true
          
          const itemData = {
            spn: this.formData.spn !== '' && this.formData.spn !== null ? Number(this.formData.spn) : 0,
            fmi: this.formData.fmi !== '' && this.formData.fmi !== null ? Number(this.formData.fmi) : 0,
            dtc: this.formData.dtc,
            description: this.formData.description,
            dtcType: Number(this.formData.dtcType)
          }

          let action = ''
          let payload = null

          if (this.isEdit) {
            action = 'app-dtc/updateItem'
            payload = {
              dtcTableId: this.dtcTableId,
              id: this.formData.id,
              ...itemData
            }
          } else {
            action = 'app-dtc/addItems'
            payload = {
              dtcTableId: this.dtcTableId,
              items: [itemData]
            }
          }
          
          store.dispatch(action, payload)
            .then(() => {
              this.$toast({
                component: ToastificationContent,
                props: { title: this.$t('Salvo com sucesso'), icon: 'CheckIcon', variant: 'success' }
              })
              this.$emit('saved')
              this.$refs.bModal.hide()
            })
            .catch(() => {
              this.$toast({
                component: ToastificationContent,
                props: { title: this.$t('Erro ao salvar código'), icon: 'AlertTriangleIcon', variant: 'danger' }
              })
            })
            .finally(() => {
              this.isSaving = false
            })
        }
      })
    },
    resetModal() {
      this.formData = { id: null, spn: '', fmi: '', dtc: '', description: '', dtcType: 0 }
      if (this.$refs.formObserver) {
        this.$refs.formObserver.reset()
      }
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
